export default __webpack_public_path__ + "static/media/spin.49b598f6.png";